var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.75L4.72782 12.5321C4.69788 12.4964 4.51019 12.2499 4.51019 12.2499C3.60951 11.0636 3.1229 9.6145 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8773 9.61389 16.391 11.0624 15.4908 12.2483L15.4898 12.2499C15.4898 12.2499 15.3023 12.4964 15.2744 12.5295L10 18.75ZM5.50782 11.4969C5.50782 11.4969 5.6537 11.6895 5.68694 11.7309L10 16.8174L14.3188 11.7237C14.3462 11.6892 14.493 11.4951 14.493 11.4951C15.2288 10.5258 15.6264 9.34195 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4919 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.37362 9.34261 4.77156 10.5271 5.50782 11.4969Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 11.25H11.875V6.25H8.12501V11.25H6.87501V6.25C6.87535 5.91859 7.00716 5.60085 7.24151 5.3665C7.47585 5.13215 7.79359 5.00035 8.12501 5H11.875C12.2064 5.00035 12.5242 5.13215 12.7585 5.3665C12.9928 5.60085 13.1247 5.91859 13.125 6.25V11.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 10H9.37501V11.25H10.625V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 7.5H9.37501V8.75H10.625V7.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d867b7a2c36e443eb161b0d5ef04b00d.svg";
export { ForwardRef as ReactComponent };